<h1 mat-dialog-title>Deseja continuar com a criação desse DIO?</h1>
<div mat-dialog-content>
    <div class="lh-sm mb-3">
        Já existe um DIO criado com os mesmos dados informados. <br />
        Verifique os dados informados para evitar a criação de DIOs duplicados!
    </div>
    <div class="container-fluid bg-gray-200 pt-2 pb-3 rounded">
        <div class="row">
            <div class="col-12 mb-2">
                <span class="fw-bold fs-7 opacity-75">NÚMERO</span>
                <div class="lh-sm">{{ data.dio.numero }}</div>
            </div>
            <div class="col-12 col-md-6 mb-2 mb-md-0">
                <span class="fw-bold fs-7 opacity-75">DATA INICIO OPERAÇÃO</span>
                <div class="lh-sm">{{ data.dio.dataPeriodoInicioOperacao | date:'dd/MM/yyyy' }}</div>
            </div>
            <div class="col-12 col-md-6 mb-2 mb-md-0">
                <span class="fw-bold fs-7 opacity-75">PREFIXO</span>
                <div class="lh-sm">{{ data.dio.alocacao.codigo }}</div>
            </div>                    
            <div class="col-12 col-md-6 mb-2 mb-md-0">
                <span class="fw-bold fs-7 opacity-75">CONTRATO</span>
                <div class="lh-sm">{{ data.dio.contrato.nome }}</div>
            </div>
            <div class="col-12 col-md-6 mb-2 mb-md-0">
                <span class="fw-bold fs-7 opacity-75">CONDUTOR</span>
                <div class="lh-sm">{{ data.dio.condutor.nome }}</div>
            </div>
            <div class="col-12 col-md-6 mb-2 mb-md-0">
                <span class="fw-bold fs-7 opacity-75">ORGÃO</span>
                <div class="lh-sm">{{ data.dio.orgao.nome }}</div>
            </div>
            <div class="col-12 col-md-6 mb-2 mb-md-0">
                <span class="fw-bold fs-7 opacity-75">SERVIÇO</span>
                <div class="lh-sm">{{ data.dio.servico.titulo }}</div>
            </div>
            <div class="col-12 col-md-6 mb-2">
                <span class="fw-bold fs-7 opacity-75">DATA CRIAÇÃO DO DIO</span>
                <div class="lh-sm">{{ data.dio.created_at | date:'dd/MM/yyyy HH:mm' }}</div>
            </div>
            <div class="col-12 col-md-6 mb-2 mb-md-0">
                <span class="fw-bold fs-7 opacity-75">RESPONSÁVEL CRIAÇÃO DIO</span>
                <div class="lh-sm">{{ data.dio.criadorEmail }}</div>
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions class="px-3 pb-3 justify-content-end">
    <button mat-button mat-dialog-close class="px-3">Cancelar</button>
    <button mat-flat-button color="accent" (click)="confirm()">Continuar</button>
</div>
